/**
 * Simple object to wrap the localStorage
 *
 */

export default {
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value) || value);
  },

  get(key) {
    let value = localStorage.getItem(key);

    if (typeof value === 'string') {
      try {
        value = JSON.parse(value);
      } catch (e) {
        /* Fail to parse the string so return it */
      }
    }
    return value;
  },

  unset(key) {
    localStorage.removeItem(key);
  },
};



// WEBPACK FOOTER //
// src/lib/api/storage.js